// @ts-check
import Popup from "Components/Common/popup";
import 'Styles/commonComponents/settings/textSetting.scss';
import IconsContainer from "Utils/IconsContainer";
import { observer } from "mobx-react";
import React from "react";

/**
 * @param {{
 * id?: string | undefined,
 * className?: string,
 * title: string,
 * helperText?: string | undefined,
 * disabled: boolean,
 * value: string,
 * buttonValue: string | undefined,
 * onClick: () => void,
 * textOptions?: {
 *  wordBreak?: import('csstype').Property.WordBreak
 *  }
 * }} props 
 * @returns {React.JSX.Element}
 */
const TextSetting = (props) => {
    return (
        <div className={'setting-container text-setting' + (props.className ? ' ' + props.className : '')}>

            <div className='setting-title text-setting-title'>
                {props.title}
                {props.helperText ?
                    <Popup
                        popupText={props.helperText}
                        className='fast-info-popup'>
                        {IconsContainer.Get('ci-info')}
                    </Popup>
                    : ''}
            </div>

            <div className='text-setting-value-block'>
                <div
                    className="text-setting-value"
                    style={{ wordBreak: props.textOptions?.wordBreak }}>
                    {props.value}
                </div>
                {
                    props.buttonValue ?
                        <button
                            id={props.id}
                            onClick={(e) => props.onClick()}
                            className={props.disabled ? 'disabled' : ''}>
                            {props.buttonValue}
                        </button>
                        : ''
                }
            </div>

        </div>
    )
}

export default observer(TextSetting);